import ticketsApiClient from "./base";

export const plentyCredentialsApi = {
  // Credentials management
  getCredentials: () => {
    return ticketsApiClient.get("/plenty/credentials/");
  },

  createCredential: (data) => {
    return ticketsApiClient.post("/plenty/credentials/", data);
  },

  deleteCredential: (credentialId) => {
    return ticketsApiClient.delete(`/plenty/credentials/${credentialId}`);
  },

  updateCredential: (credentialId, data) => {
    return ticketsApiClient.put(`/plenty/credentials/${credentialId}`, data);
  },

  toggleActiveCredential: (credentialId) => {
    return ticketsApiClient.post(
      `/plenty/credentials/${credentialId}/toggle-active`,
    );
  },

  testCredential: (data) => {
    return ticketsApiClient.post(`/plenty/credentials/test`, data);
  },
};
